export const ALL_STORES_KEY = 'all-stores';
export const getAllStoresOptionItem = (label: string) => ({ value: ALL_STORES_KEY, label: label });
